import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.sections.shipments.title',
    defaultMessage: 'Shipments',
    description: 'title of the shipments section on the settings page',
  },
  settings: {
    showCreateShipmentButtonMobile: {
      id: 'pages.settings.sections.shipments.settings.showCreateShipmentButtonMobile',
      defaultMessage: 'Show create button on mobile devices',
      description: 'Title of the show create shipment button on mobile setting',
    },
    alwaysUnpackInboundShipments: {
      id: 'pages.settings.sections.shipments.settings.alwaysUnpackInboundShipments',
      defaultMessage: 'Always unpack inbound shipments',
      description: 'Title of the always unpack inbound shipments setting',
    },
    dontPrintPackingSlipForDestinationLocations: {
      id: 'pages.settings.sections.shipments.settings.dontPrintPackingSlipForDestinationLocations',
      defaultMessage: "Don't print packing slip for destination locations",
      description: 'Title of the dont print packing slip for destination locations setting',
    },
  },
  locationsDrawer: {
    title: {
      id: 'pages.settings.sections.shipments.locationsDrawer.title',
      defaultMessage: 'Select destination locations',
      description: 'Title of the locations drawer in the shipments settings',
    },
  },
  feedback: {
    noLocationsSelected: {
      id: 'pages.settings.sections.shipments.feedback.noLocationsSelected',
      defaultMessage: 'No locations selected',
      description: 'Feedback message when no locations are selected in the settings page',
    },
    settingsUpdated: {
      id: 'pages.settings.feedback.settingsUpdated',
      defaultMessage: 'Settings updated',
      description: 'Success message of the update settings action',
    },
    settingsNotUpdated: {
      id: 'pages.settings.feedback.settingsNotUpdated',
      defaultMessage: 'Settings could not be updated',
      description: 'Error message of the update settings action',
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
